import { render } from "./NewSupplier.vue?vue&type=template&id=2177c9ac&scoped=true"
import script from "./NewSupplier.vue?vue&type=script&lang=js"
export * from "./NewSupplier.vue?vue&type=script&lang=js"

import "./NewSupplier.vue?vue&type=style&index=0&id=2177c9ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2177c9ac"]])

export default __exports__